import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';

import { CGISearch } from './cgi-search.component';

@NgModule({
	declarations: [CGISearch],
	imports: [CommonModule, TranslateModule.forChild(), FormsModule],
	exports: [CGISearch],
	providers: [PromptuaryService],
})
export class CGISearchModule {}
